import { Injectable }                      from '@angular/core';
import { ModalService }                    from '@app/core/modals/modal.service';
import { ShowInvalidTenantModalComponent } from '@app/core/modals/show-invalid-tenant/show-invalid-tenant-modal.component';
import { ModalIdentifierEnum }             from '@core/modals/modal.model';


@Injectable()
export class ShowInvalidTenantModalService {

	constructor(
		private modalService: ModalService
	) {}

	showInvalidTenantModalComponent() {
		return this.modalService.createModal(
			ShowInvalidTenantModalComponent,
			[
				{ key: 'modalIdentifier', value: ModalIdentifierEnum.INVALID_TENANT }
			],
			null,
			null,
			null,
			{
				asFullpage: {
					animation: true
				}
			}
		);
	}
}
